module.exports = __webpack_public_path__ + "img/chura_venture_logo.5e13e631.png";